import { createContext, useContext, useRef, useState, useEffect } from 'react';

const SectionContext = createContext();

export function SectionProvider({ children }) {
  const sectionRefs = useRef({});
  const [activeSection, setActiveSection] = useState('');

  const registerSection = (id, ref) => {
    sectionRefs.current[id] = ref;
  };

  const scrollToSection = (id) => {
    const ref = sectionRefs.current[id];
    if (ref?.current) {
      const headerHeight = 86;
      const elementPosition = ref.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      window.history.pushState(null, '', `#${id}`);
      setActiveSection(id);
    }
  };

  // Отслеживание активной секции при скролле
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      
      Object.entries(sectionRefs.current).forEach(([id, ref]) => {
        if (ref?.current) {
          const { offsetTop, offsetHeight } = ref.current;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(id);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <SectionContext.Provider value={{ 
      registerSection, 
      scrollToSection,
      activeSection
    }}>
      {children}
    </SectionContext.Provider>
  );
}

export function useSectionRegister(id) {
  const { registerSection } = useContext(SectionContext);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      registerSection(id, ref);
    }
  }, [id, registerSection]);

  return ref;
}

export function useSectionNavigation() {
  return useContext(SectionContext);
}